<template>
  <v-flex xs12 pt-0 mt-1>
    <v-divider />
    <selectable @toogle_selected="handleToogleSelected" :disabled="selectionDisabled" :isSelected="record.selected">
      <v-flex :class="{xs7: !admin, xs10: admin}" @contextmenu.prevent="toogleView" @click="$emit('transaction-click', record)">
        <v-layout row wrap body-1>
          <v-flex xs12 py-0>
            {{record.scheduled_bank_transaction.subject.social_name}}
            {{record.scheduled_bank_transaction.subject.document_type.toUpperCase()}}
            {{mask(record.scheduled_bank_transaction.subject.document_type, record.scheduled_bank_transaction.subject.document_number)}}
          </v-flex>
          <v-flex xs12 py-0 v-if="!isReverseExchange">
            {{i18n('Valor recebido')}}: {{l(record.value, record.currency)}} <span style="color: red" v-if="record.scheduled_bank_transaction.from_credit_card_id">Cartão de crédito</span>
            <span v-if="record.exchanged_value != null">{{i18n('convertido para')}}: {{l(record.exchanged_value, record.exchange_currency)}} ({{record.exchange_rate}})</span>
          </v-flex>
          <v-flex xs12 py-0 v-if="isReverseExchange">
            {{i18n('Valor a transferir')}}: {{l(record.exchanged_value, record.exchange_currency)}}
            <span v-if="record.exchange_approved == true">{{i18n('convertido de')}}: {{l(record.value, record.currency)}} ({{record.exchange_rate}})</span>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs3 py-0 text-xs-right @contextmenu.prevent="toogleView" v-if="!admin">
        <v-btn round small color="error" v-if="allowTransactionCancellation()">
          <CancelModal title="Cancelar transação" @onConfirm="cancellationConfirmed">
            {{i18n('Cancelar')}}
          </CancelModal>
        </v-btn>
      </v-flex>
      <v-flex xs2 py-0 text-xs-right @contextmenu.prevent="toogleView">
        <v-layout row wrap caption>
          <v-flex xs12 py-0>
            {{record.currency}}
            <v-icon class="arrow-icon-small">arrow_forward</v-icon>
            {{record.exchange_currency}}
          </v-flex>
          <v-flex xs12 py-0>
            {{humanMovementDate}}
          </v-flex>
        </v-layout>
      </v-flex>
      <transition name="fade">
        <v-flex xs12 v-if="current_view === 'detailed'">
          <v-layout row wrap body-1>
            <v-flex xs12 py-0>
              ID: {{record.scheduled_bank_transaction.id}}
            </v-flex>
          </v-layout>
        </v-flex>
      </transition>
    </selectable>
  </v-flex>
</template>
<script>
import utils from "./shared/Utils"
import SelectableListItem from "./components/SelectableListItem"
import DeleteModal from "./DeleteModal"

export default {
  name: 'TransactionWithScheduleItem',
  components: { 'selectable': SelectableListItem, 'CancelModal':  DeleteModal },
  props: {
    record: {
      type: Object
    },
    selectionDisabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      current_view: 'short',
      admin: false
    }
  },
  computed: {
    humanMovementDate() {
      return utils.dbDateToHuman(this.record.movement_date)
    },
    isReverseExchange() {
      return this.record.scheduled_bank_transaction &&
        (this.record.scheduled_bank_transaction.estimated_value_until_exchange === true)
    }
  },
  methods: {
    i18n(str) {
      return this.$root.l(str)
    },
    cancellationConfirmed(){
      let successCallback = (response) => {
        this.$emit('canceledTransaction')
      }
      let errorCallback = (response) => {
        console.log('errorCallback', response)
      }
      let token = this.$cookies.get('api_token')
      let url = this.$root.urls.customer__scheduled_bank_transactions + `/${this.record.scheduled_bank_transaction.id}`
      this.$http.delete(url, { headers: { Authorization: `Bearer ${token}` }}).then(successCallback, errorCallback)
    },
    toogleView() {
      this.current_view = (this.current_view === 'short') ? 'detailed' : 'short'
    },
    l(number_value, currency) {
      return utils.currencyToLocal(number_value, currency)
    },
    handleToogleSelected() {
      this.$set(this.record, 'selected', !this.record.selected)
    },
    mask(format, value) {
      return utils.mask(format, value)
    },
    openInNewWindow(url) {
      window.open(url, '_blank')
    },
    allowTransactionCancellation() {
      if (!this.record.wire_id && !this.record.exchange_id && this.record.source_type == 'TED-PRE') {
        return true
      }
      return false
    }
  },
  mounted() {
    this.admin = this.$cookies.isKey('admin') && this.$cookies.get('admin') === 'true'
  }
}
</script>



// WEBPACK FOOTER //
// src/TransactionWithScheduleItem.vue